var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumToString(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 27,
    viewBox: "0 0 45 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 2,
    fill: "#FFD822"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 10,
    height: 19,
    rx: 2,
    fill: "#FFB922"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.058 15V6.04L9.038 7.02H6.098V5.2H10.326V15H8.058Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    width: 19,
    height: 19,
    rx: 2,
    fill: "#08E564"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 8,
    width: 10,
    height: 19,
    rx: 2,
    fill: "#1AB00A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.628 22V20.53L36.488 20.208V17.576C36.488 17.1093 36.3433 16.7453 36.054 16.484C35.774 16.2227 35.34 16.092 34.752 16.092C34.3507 16.092 33.954 16.1573 33.562 16.288C33.1793 16.4093 32.8527 16.5773 32.582 16.792L31.798 15.266C32.2087 14.9767 32.7033 14.7527 33.282 14.594C33.8607 14.4353 34.4487 14.356 35.046 14.356C36.194 14.356 37.0853 14.6267 37.72 15.168C38.3547 15.7093 38.672 16.554 38.672 17.702V22H36.628ZM34.332 22.112C33.744 22.112 33.24 22.014 32.82 21.818C32.4 21.6127 32.078 21.3373 31.854 20.992C31.63 20.6467 31.518 20.2593 31.518 19.83C31.518 19.382 31.6253 18.99 31.84 18.654C32.064 18.318 32.414 18.0567 32.89 17.87C33.366 17.674 33.9867 17.576 34.752 17.576H36.754V18.85H34.99C34.4767 18.85 34.122 18.934 33.926 19.102C33.7393 19.27 33.646 19.48 33.646 19.732C33.646 20.012 33.7533 20.236 33.968 20.404C34.192 20.5627 34.4953 20.642 34.878 20.642C35.242 20.642 35.5687 20.558 35.858 20.39C36.1473 20.2127 36.3573 19.956 36.488 19.62L36.824 20.628C36.6653 21.1133 36.376 21.482 35.956 21.734C35.536 21.986 34.9947 22.112 34.332 22.112Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4141 11L14.001 11",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11L27.6739 13.5981V8.40192L31 11Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5859 16L30.999 16",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L17.3261 13.4019V18.5981L14 16Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumToString);
export default __webpack_public_path__ + "static/media/num_to_string.96cf588d8341a07e2d5a97c20d68b0ee.svg";
export { ForwardRef as ReactComponent };